import type { StatusTone } from '@/lib/status';

// awaiting_assets is `info`, like in_progress: the vendor has it, not you.
export const SETUP_STATUS_META: Record<string, { label: string; tone: StatusTone; hint: string }> = {
  ready: {
    label: 'ready',
    tone: 'success',
    hint: 'products.json validates clean, sentinel-free — waiting only on submission',
  },
  in_progress: {
    label: 'in progress',
    tone: 'info',
    hint: 'A run is still building or verifying this folder',
  },
  awaiting_assets: {
    label: 'waiting on vendor',
    tone: 'info',
    hint: 'The vendor still owes source material (sheets, images, barcodes)',
  },
  submitted: {
    label: 'submitted',
    tone: 'info',
    hint: 'Submitted in Setup Preview — the next run checks the catalog, then archives it',
  },
  mapping_only: {
    label: 'mapping only',
    tone: 'neutral',
    hint: 'No new products to build — only line-to-catalog mapping debt',
  },
  parked: {
    label: 'parked',
    tone: 'neutral',
    hint: 'Its journey is closed — revived if the journey reopens',
  },
  archived: {
    label: 'archived',
    tone: 'neutral',
    hint: 'Journey cleared — kept for history',
  },
};
